module.exports = __webpack_public_path__ + "media/images/items/big-1-609900dd51de44416dad79b4fb5e59f2.jpg";